import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { FULL_DAY_NAMES } from '../../utils/constants/dates';

/**
 * Firebase Firestore service functions for venue operations.
 */

export const fetchVenuesFromFirestore = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'venues'));
    const venuesData = [];

    querySnapshot.forEach((doc) => {
      venuesData.push({ id: doc.id, ...doc.data() });
    });

    return venuesData;
  } catch (error) {
    throw new Error(`Error fetching venues: ${error.message}`);
  }
};

export const fetchBusinessHoursFromFirestore = async (venueId) => {
  try {
    const businessHoursRef = collection(db, 'venues', venueId, 'businessHours');
    const querySnapshot = await getDocs(businessHoursRef);
    const businessHours = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      // Transform Firestore field names to match component expectations
      businessHours.push({
        id: doc.id,
        dayOfWeek: data.dayOfWeek,
        available: data.open ? 1 : 0,
        publicFrom: data.publicFrom,
        publicTo: data.publicTo,
        publicSplitFrom: data.publicSplitFrom,
        publicSplitTo: data.publicSplitTo,
        workdayFrom: data.workdayFrom,
        workdayTo: data.workdayTo,
      });
    });

    // Sort by day of week (Monday = 1, Sunday = 7)
    businessHours.sort((a, b) => FULL_DAY_NAMES.indexOf(a.dayOfWeek) - FULL_DAY_NAMES.indexOf(b.dayOfWeek));

    return businessHours;
  } catch (error) {
    throw new Error(`Error fetching business hours: ${error.message}`);
  }
};

/**
 * Update the Tips feature enabled status for a venue
 * @param {string} venueId - The venue document ID
 * @param {boolean} isEnabled - Whether the Tips feature should be enabled
 * @returns {Promise<void>}
 */
export const updateVenueTipsFeature = async (venueId, isEnabled) => {
  if (!venueId) {
    throw new Error('Venue ID is required');
  }

  try {
    const venueRef = doc(db, 'venues', venueId);
    await updateDoc(venueRef, {
      isTipsFeatureEnabled: isEnabled,
    });
  } catch (error) {
    console.error('Error updating venue Tips feature:', error);
    throw new Error(`Error updating venue Tips feature: ${error.message}`);
  }
};
